import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import type { EnvironmentTarget } from '@kerberos-compliance/compliance-shared-ui';
import { EnvironmentTargetMap } from '@kerberos-compliance/compliance-shared-ui';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  public readonly baseAdpHost = environment.config.adpHost.url;

  public readonly baseUrl = environment.config.baseUrl;

  public readonly signInEndpoint = environment.config.adpHost.signIn;

  public readonly tenantId = environment.config.tenant;

  public readonly hankoApiUrl = environment.config.hanko.apiUrl;

  public readonly hankoPasskeyLimit = environment.config.hanko.passkeyLimit;

  public readonly maintenanceInfoUrl = environment.config.maintenanceInfoUrl;

  public readonly adminDeskBaseUrl = environment.config.adminDeskBaseUrl;

  public readonly isProduction = environment.target === EnvironmentTargetMap.Production;

  public readonly isStage = environment.target === EnvironmentTargetMap.Stage;

  public readonly isLocal = environment.target === EnvironmentTargetMap.Local;

  /**
   * Local, preview and e2e builds. Deliberately excludes Stage: Stage mirrors production and is
   * demoed to stakeholders, so it is gated like production (see `docs/dx-tooling.md`).
   */
  public readonly isNonProduction = (
    [EnvironmentTargetMap.Local, EnvironmentTargetMap.Preview, EnvironmentTargetMap.E2e] as EnvironmentTarget[]
  ).includes(environment.target);

  public readonly version = environment.version;

  public readonly target = environment.target;
}
